import React, { Component } from 'react'
import './studymaterialcard.css'
import '../DOC/docCard.css'
import StudymDoc from './studymDoc';

export default class 
cardView extends Component {
    combinedMap = (Study_Material_files, topic_name, topic_id) => {
        let combinedArray = [];
        if (Study_Material_files != undefined) {
            let availKey = Object.keys(Study_Material_files)
            for (let index = 0; index < availKey.length; index++) {
                let ObjArr = Study_Material_files[availKey[index]];
                for (let index2 = 0; index2 < ObjArr.length; index2++) {
                    combinedArray = [...combinedArray, { ...ObjArr[index2], type: availKey[index], topic_name,  topic_id}]
                }
            }
        }
        return combinedArray;
    }

    subjectsData = (Material_topic) => {
        let arr = [];
        arr = [...arr, ...this.combinedMap(Material_topic.studyMaterialMap, Material_topic?.topicName ?? Material_topic.subjectName, Material_topic?.topicId ?? 0)]
        if (Material_topic.subtopicList != undefined) {
            for (let i = 0; i < Material_topic.subtopicList.length; i++) {
                arr = [...arr, ...this.subjectsData(Material_topic.subtopicList[i])]
            }
        };
      
        return arr;
    }

    handleClick = (el, type) => {
      const fileName = el?.file_name ?? "";
      const ext = fileName.split(".").pop().toLowerCase();

      const imageTypes = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
      const audioTypes = ['mp3', 'aac', 'wav', 'ogg'];
      const documentTypes = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt'];

      if (imageTypes.includes(ext)) {
        this.props.image(el);
      } else if (audioTypes.includes(ext)) {
        this.props.listen(el);
      } else if (documentTypes.includes(ext)) {
        this.props.view(el);
      } else if (type === 'VDOCipher' || (el.videoID && el.is_vdocipher)) {
        this.props.vdocipherApicalling(el);
      } else if (type === 'Vimeo' || (el.videoID && el.is_vimeo)) {
        this.props.vimeo(el);
      } else if (type === 'YoutubeURL' || el.youtubeVideoID) {
        this.props.youtubeVideo(el);
      } else {
        this.props.view(el);
      }
    };

    render() {
        let allData = this.subjectsData(this.props.subjectData)
        return (
            <div>
                { allData&& allData.map((data, index) => (
                    ((this.props.topicId==0 || (this.props.topicId==data.topic_id)) && (this.props.search == "" || data.title.toUpperCase().includes(this.props.search.toUpperCase())))&&
                    <StudymDoc key={index} el={data}
                        heading_name={data.title}
                        date={data.student_file_share_date}
                        type={data.type}
                        file_name={data?.file_name??""}
                        topic={data.topic_name}
                        category_name={data.category_name}
                        download={this.props.download} view={this.props.view}
                         downloadvimeo={this.props.downloadvimeo}
                        UpdatVimeoWatchCall={this.props.UpdatVimeoWatchCall}
                        vdocipherApicalling={this.props.vdocipherApicalling}
                        youtubeVideo={this.props.youtubeVideo}
                        vimeo={this.props.vimeo}
                        image={this.props.image}
                        listen={this.props.listen}
                        handleClick={this.handleClick}
                        is_readonly={data.is_readonly}
                        vimeo_video_downlodable={this.props.subjectData.vimeo_video_downlodable }
                        video_url={data.video_url}
                        posterUrl={data.posterUrl}
                        posterList={data.posterList}
                    />
                    
                    )
                )
                    }
            </div>
        )
    }
}
